// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2706":"efdfc9d6","3091":"efdfc9d6","4161":"efdfc9d6","5472":"efdfc9d6","8153":"efdfc9d6"}[chunkId] + ".chunk.css";
};